import { ImageFields, ImagePreset } from 'types/photo';
import { IProductGiftImages } from 'types/product';

export const PRODUCT_GIFT_IMAGE_PRESETS: Record<keyof IProductGiftImages, ImagePreset> = {
  [ImageFields.MOBILE]: {
    width: 216,
    height: 198,
    title: 'Изображение подарка mobile',
  },
  [ImageFields.DESKTOP]: {
    width: 216,
    height: 198,
    title: 'Изображение подарка desktop',
  },
};

export enum PRODUCT_TAB_VALUES {
  INFO = 'info',
  CONTENT = 'content',
  PROMOTIONS = 'promotions',
  PROMOCODES = 'promocodes',
  NOTIFICATIONS = 'notifications',
}

export const MIN_RECEIPT_TITLE_LENGTH = 3;
export const MAX_RECEIPT_TITLE_LENGTH = 80;

export const SALE_TYPES = [
  { value: 1, label: 'В рублях' },
  { value: 2, label: 'В %' },
];
